import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

import WarehouseShelvingContainer from "@/screens/Warehouses/Shelving/containers/WarehouseShelvingContainer"
import {
  WarehouseShelvingSearchParamsSchema,
  WarehouseShelvingSearchParamsSchemaKeys,
} from "@/screens/Warehouses/Shelving/schemas"

export const WAREHOUSE_SHELVING_LAYOUT_ROUTE_PATH = "/app/admin/warehouses/$warehouseId/_layout/shelving"
export const WAREHOUSE_SHELVING_ROUTE_PATH = "/app/admin/warehouses/$warehouseId/shelving"

export const Route = createFileRoute(WAREHOUSE_SHELVING_LAYOUT_ROUTE_PATH)({
  validateSearch: WarehouseShelvingSearchParamsSchema,
  search: {
    middlewares: [retainSearchParams(WarehouseShelvingSearchParamsSchemaKeys.options)],
  },
  component: WarehouseShelvingContainer,
})
